module.exports = __webpack_public_path__ + "static/media/StrainThreshold.783d00b4.svg";